import { request } from '@/utils/request';

import { startAdminCheck, finishAdminCheck } from '@/store/modules/user';
import { getRequestErrorMessage } from '@/utils/requestError';
import { userRole } from '@/utils/roles';

export const fetchRecommendationStatistics = async (params = {}) => (await request.get('/user/admin/recommendation-statistics/', { params })).data;

export const requestPasswordReset = async email => (await request.post('/user/password-reset/', { email })).data;
export const confirmPasswordReset = async data => (await request.post('/user/password-reset/confirm/', data)).data;
export const fetchMyTags = async () => (await request.get('/user/my-tags/')).data;
export const addMyTag = async tagId => (await request.post('/user/my-tags/', { tag_id: tagId })).data;
export const deleteMyTag = async tagId => request.delete(`/user/my-tags/${tagId}/`);
export const fetchAdminUsers = async (params = {}) => (await request.get('/user/admin/users/', { params })).data;
export const fetchLoginSessions = async (params = {}) => (await request.get('/user/sessions/', { params })).data;
export const fetchMyProfile = async () => (await request.get('/user/me/')).data;
export const requestEmailVerification = async () => (await request.post('/user/email-verification/', {}, { timeout: 30000 })).data;
export const confirmEmailVerification = async verificationToken => (await request.post('/user/email-verification/confirm/', { verification_token: verificationToken })).data;
export const fetchEmailChange = async () => (await request.get('/user/email-change/')).data;
export const requestEmailChange = async data => (await request.post('/user/email-change/', data, { timeout: 30000 })).data;
export const cancelEmailChange = async currentPassword => request.delete('/user/email-change/', { data: { current_password: currentPassword } });
export const confirmEmailChange = async data => (await request.post('/user/email-change/confirm/', data)).data;
export const revokeLoginSession = async (id, currentPassword) => request.post(`/user/sessions/${id}/revoke/`, { current_password: currentPassword });
export const logoutAllSessions = async currentPassword => request.post('/user/logout-all/', { current_password: currentPassword });
export const fetchAdminStatistics = async () => (await request.get('/user/admin/statistics/')).data;
export const fetchAuditEvents = async (params = {}) => (await request.get('/user/admin/audit-events/', { params })).data;

let adminCheckSequence = 0;
const pendingAdminChecks = new Map();

// 使用后端保护的只读接口重新验证权限，避免使用被撤销的旧身份。
export const checkAdminAccess = () => (dispatch, getState) => {
  const { isAuthenticated, userInfo, sessionVersion } = getState().user;
  if (!isAuthenticated || !userInfo.id || !userInfo.username) return Promise.resolve('denied');
  const key = `${sessionVersion}:${userInfo.id}`;
  if (pendingAdminChecks.has(key)) return pendingAdminChecks.get(key);
  const checkId = ++adminCheckSequence;
  dispatch(startAdminCheck(checkId));
  const pending = (async () => {
    let status;
    let role;
    let isAdmin;
    let error = '';
    try {
      const response = await fetchAdminUsers({ keyword: userInfo.username });
      const users = Array.isArray(response) ? response : response?.data;
      if (!Array.isArray(users)) throw new Error('权限校验响应无效');
      const currentUser = users.find(user => String(user.id) === String(userInfo.id));
      role = userRole(currentUser);
      isAdmin = currentUser?.is_admin === true;
      status = currentUser?.is_active !== false && ['admin', 'super_admin'].includes(role) ? 'allowed' : 'denied';
    } catch (err) {
      status = [401, 403].includes(err.response?.status) ? 'denied' : 'error';
      if (status === 'error') error = getRequestErrorMessage(err, '管理员权限校验失败，请稍后重试');
    }
    dispatch(finishAdminCheck({ checkId, sessionVersion, userId: userInfo.id, status, error, role, isAdmin }));
    return status;
  })().finally(() => pendingAdminChecks.delete(key));
  pendingAdminChecks.set(key, pending);
  return pending;
};
export const updateAdminUser = async (id, action) => {
  if (!['freeze', 'unfreeze', 'grant-admin', 'revoke-admin'].includes(action)) throw new Error('无效操作');
  return (await request.post(`/user/admin/users/${id}/${action}/`)).data;
};
